import { Box, Button, FormControl, Grid, IconButton, Stack, TextField, Tooltip, useMediaQuery } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { T1aPartnerFormValues } from '../../../app/models/partners';
import { useStore } from '../../../app/stores/store';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

interface FormProps {
    showFormContainerHandler: () => void;
    isChecked: boolean;
}

const initialFormvalues: T1aPartnerFormValues = {
    partnerNameCheck: false,
    resellerNameCheck: false,
    partnerName: '',
    resellerName: '',
}

const root = (isMobile: boolean) => {
    return {
        margin: '0 auto',
        overflow: 'hidden',
        padding: 1,
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        boxShadow: 24,
        p: 4,

        '& h5': {
            fontWeight: 500,
        },
        '& .MuiInputBase-input': {
            color: '#000'
        },
        '& .MuiFormLabel-root': {
            color: '#000'
        },
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000'
        },
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000"
        },
        '& .MuiSelect-iconOutlined': {
            color: '#000'
        },
    }
}

const T1aPartnerForm = ({ showFormContainerHandler, isChecked }: FormProps) => {

    const { adminStore } = useStore();
    const { setAdminKobhovedPartner, loadAdminKobhoveds } = adminStore;

    const matches = useMediaQuery('(min-width:900px)');
    const resetHandler = () => {
        loadAdminKobhoveds();
    }

    return (
        <Box component='div'
            sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
        >
            <Formik
                initialValues={initialFormvalues}
                onSubmit={(values) => {
                    setAdminKobhovedPartner("partnerName", values.partnerName);
                    setAdminKobhovedPartner("resellerName", values.resellerName);
                    loadAdminKobhoveds();
                }}
            >
                {({ values, handleChange, handleBlur, isSubmitting, setFieldValue }) => (
                    <Form autoComplete='off'>
                        <Box component='div' sx={root(matches)}>
                            <Stack direction='column' spacing={1}>
                                <FormControl>
                                    <Field
                                        type="text"
                                        label="Search by Partner Name"
                                        component={TextField}
                                        id="partnerName"
                                        name="partnerName"
                                        placeholder="Search by Partner Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.partnerName}
                                        variant="outlined"
                                    />
                                </FormControl>
                                <FormControl>
                                    <Field
                                        type="text"
                                        label="Search by Reseller Name"
                                        component={TextField}
                                        id="resellerName"
                                        name="resellerName"
                                        placeholder="Search by Reseller Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.resellerName}
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Stack>
                            {matches ?
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    pt={2}
                                >
                                    <Button size="medium" variant="contained" name='search' id='search' type='submit' >Search</Button>
                                    <Button size="medium"
                                        disabled={!isChecked}
                                        onClick={showFormContainerHandler} name='createpartner' variant='contained'>Create Partner</Button>
                                    <Button size="medium" variant="contained" name='reset' id='reset' onClick={resetHandler} >Reset</Button>
                                </Stack>
                                :
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    pt={2}
                                >
                                    <Tooltip title="Search" placement='right'>
                                        <IconButton type='submit' >
                                            <SearchOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Button size="medium"
                                        disabled={!isChecked}
                                        onClick={showFormContainerHandler} name='createpartner' variant='contained'>Create Partner</Button>
                                    <Tooltip title="Reset" placement='right'>
                                        <IconButton onClick={resetHandler}>
                                            <RotateLeftIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            }
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>
    )
}
export default observer(T1aPartnerForm);